<template><svg
        viewBox="-2 -2 19 19"
        xmlns="http://www.w3.org/2000/svg"
>
    <path d="M5.24541 12.7573C5.05696 12.7573 4.86851 12.6852 4.72495 12.5416L0.215947 8.0325C-0.0719823 7.7447 -0.0719823 7.27938 0.215947 6.99158C0.503741 6.70379 0.96893 6.70379 1.25686 6.99158L5.24541 10.9801L13.7432 2.48245C14.031 2.19465 14.4962 2.19465 14.7841 2.48245C15.0719 2.77038 15.0719 3.23557 14.7841 3.52349L5.766 12.5416C5.62244 12.6852 5.43385 12.7573 5.24541 12.7573V12.7573Z"/>
</svg>
</template>